import { useNavigate } from "react-router-dom";
import { ArrowLeft, Headphones, Phone, MessageCircle, Mail, Clock } from "lucide-react";
import { Button } from "../components/ui/button";

const PHONE = "+33753202093";
const EMAIL = "contact@youmigreenvtc.com";

export const SupportPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="px-4 py-4 border-b border-zinc-800">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/client")} className="p-2 rounded-lg hover:bg-zinc-800 transition-colors" data-testid="back-client-btn">
            <ArrowLeft className="w-5 h-5 text-zinc-400" />
          </button>
          <Headphones className="w-5 h-5 text-cyan-400" />
          <h1 className="text-lg font-bold text-white font-['Outfit']">Assistance</h1>
        </div>
      </header>

      <main className="px-4 py-8 max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-cyan-500/15 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Headphones className="w-8 h-8 text-cyan-400" />
          </div>
          <p className="text-zinc-400 text-sm">
            Notre equipe est disponible pour vous aider.
          </p>
        </div>

        <div className="space-y-3 mb-8">
          <a href={`tel:${PHONE}`} className="block" data-testid="call-btn">
            <Button className="w-full py-6 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-base font-medium">
              <Phone className="w-5 h-5 mr-3" />
              Appeler : 07 53 20 20 93
            </Button>
          </a>

          <a href={`https://wa.me/33753202093`} target="_blank" rel="noopener noreferrer" className="block" data-testid="whatsapp-btn">
            <Button className="w-full py-6 bg-green-600 hover:bg-green-700 text-white rounded-xl text-base font-medium">
              <MessageCircle className="w-5 h-5 mr-3" />
              WhatsApp
            </Button>
          </a>

          <a href={`mailto:${EMAIL}`} className="block" data-testid="email-btn">
            <Button variant="outline" className="w-full py-6 border-zinc-700 text-zinc-300 hover:bg-zinc-800 rounded-xl text-base font-medium">
              <Mail className="w-5 h-5 mr-3" />
              {EMAIL}
            </Button>
          </a>
        </div>

        <div className="glass-card rounded-xl p-5 border border-zinc-800">
          <div className="flex items-center gap-2 mb-3">
            <Clock className="w-4 h-4 text-emerald-500" />
            <h3 className="text-white font-medium text-sm">Horaires</h3>
          </div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-zinc-400">Lundi - Samedi</span>
              <span className="text-white">06:00 - 23:00</span>
            </div>
            <div className="flex justify-between">
              <span className="text-zinc-400">Dimanche</span>
              <span className="text-white">07:00 - 22:00</span>
            </div>
            <div className="flex justify-between">
              <span className="text-zinc-400">Urgences</span>
              <span className="text-emerald-400">24h/24</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
